import api from "../../plugins/api"

const state = {
    infoObraSocial: "loading...",
    resources: []
}

const getters = {
    infoObraSocial: state => state.infoObraSocial,
    getAll: state => state.all,
    getByName: (state) => name => {
        var result = state.resources.find(x => x.name === name)
        if (!result) return { "name": "", "group": "", "value": "", "valueNoHtml": "", "id": -1 }
        else {

            // var html = html.value;
            // var div = document.createElement("div");
            // div.innerHTML = html;
            // var text = div.textContent || div.innerText || "";
            // html.valueNoHtml = text;
            return result
        };
    }
}

const mutations = {
    setAll(state, list) {
        state.resources = list;
    },
    loading(state) {
        state.resources = [{ "name": "", "group": "", "value": "", "valueNoHtml": "", "id": -1 }]
    }
}

const actions = {
    async getAll({ commit }) {
        try {
            commit("loading")
            let response = await api.zaiq().get("Resource/AdvancedGetAll");
            commit("setAll", response.data.result.items);
        } catch (e) {
            debugger
            console.log(e);
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
